import React from "react";
import Contacts from "../../components/Contacts";

const Contact = () => {
  return (
    <main>
      <Contacts />
    </main>
  );
};

export default Contact;
